import React from 'react'
import {FormattedMessage, useIntl} from 'react-intl'
import PropTypes from 'prop-types'

/* Components */
import {Button} from '@chakra-ui/react'
import {GenericModal, useGenericModal} from '../../hooks/use-generic-modal'

/* Hooks */
import useOcapiSite from '../../hooks/useOcapiSite'
import useMultiSite from '../../hooks/use-multi-site'

/* Utils */
import {isProductOrderable} from '../../utils/product-utils'

const WhereToBuyCTA = ({product}) => {
    const {isOpen, onOpen, onClose} = useGenericModal()
    const {formatMessage} = useIntl()
    const {site} = useMultiSite()
    const {channelAdvisorURL, channelAdvisorPID, showAlwaysWheretobuyEnabled} = useOcapiSite()
    const EAN = site.id === 'USA' ? product?.upc : product?.ean
    // used static height, because dynamic height that is coming from iframe content can't be implemented
    const staticHeight = 540

    const isVisible =
        channelAdvisorPID &&
        channelAdvisorURL &&
        product?.c_isWhereToBuy &&
        (showAlwaysWheretobuyEnabled || !isProductOrderable(product))

    if (!isVisible) return null

    return (
        <>
            <GenericModal colorScheme="stokkeGray" size="xl" isOpen={isOpen} onClose={onClose}>
                <iframe
                    title={formatMessage({
                        id: 'where_to_buy.modal.assistive_msg.title',
                        defaultMessage: 'Where To By Selection'
                    })}
                    src={`${channelAdvisorURL}?pid=${channelAdvisorPID}&model=${EAN}`}
                    width="100%"
                    height={staticHeight}
                />
            </GenericModal>
            <Button variant="outline" onClick={onOpen} className="where-to-buy-button">
                <FormattedMessage
                    defaultMessage="Purchase from online retailer"
                    id="product_view.button.where_to_buy"
                />
            </Button>
        </>
    )
}

WhereToBuyCTA.propTypes = {
    product: PropTypes.object
}

export default WhereToBuyCTA
